/**
 * PlayerAvatar - Jackbox-style colored avatar badge
 */

import { memo } from 'react';
import clsx from 'clsx';
import { getPlayerColor, getPlayerInitials } from '../../utils/playerColors';

interface PlayerAvatarProps {
  name: string;
  colorIndex: number;
  size?: 'sm' | 'md' | 'lg';
  showRing?: boolean;
  isCurrentUser?: boolean;
  /** Bots ("Bot Epsilon") show one distinguishing letter; the bot badge covers the corner */
  isAI?: boolean;
}

export const PlayerAvatar = memo(function PlayerAvatar({
  name,
  colorIndex,
  size = 'md',
  showRing = false,
  isCurrentUser = false,
  isAI = false,
}: PlayerAvatarProps) {
  const color = getPlayerColor(colorIndex);
  const initials = isAI
    ? (name.trim().split(/\s+/).pop() ?? name).charAt(0).toUpperCase()
    : getPlayerInitials(name);

  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base',
  };

  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-full font-bold text-white shadow-md',
        sizeClasses[size],
        color.bg,
        showRing && 'ring-2 ring-offset-2 ring-offset-white dark:ring-offset-slate-800',
        showRing && color.ring,
        isCurrentUser && 'ring-2 ring-offset-1 ring-white/50'
      )}
      title={name}
    >
      {initials}
    </div>
  );
});
